import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import GetAppIcon from "@mui/icons-material/GetApp";
import { ButtonGroup, CircularProgress, IconButton } from "@mui/material";

interface Props {
	deleteItem?: () => void;
	editItem?: () => void;
	downloadItem?: () => void;
	loading?: boolean;
	deleteLabel?: string;
	editLabel?: string;
	downloadLabel?: string;
}

export const AgGridButtons = ({
	deleteItem,
	editItem,
	downloadItem,
	downloadLabel,
	deleteLabel,
	editLabel,
	loading,
}: Props) => {
	return (
		<>
			<ButtonGroup>
				{editItem && (
					<IconButton
						color={"primary"}
						onClick={() => {
							editItem();
						}}
						title={editLabel || "Edit"}
					>
						<EditIcon style={{ cursor: "pointer" }} fontSize="small" />
					</IconButton>
				)}
				{deleteItem && (
					<IconButton
						color={"error"}
						onClick={() => {
							deleteItem();
						}}
						title={deleteLabel || "Delete"}
					>
						<DeleteIcon style={{ cursor: "pointer" }} fontSize="small" />
					</IconButton>
				)}
				{downloadItem && (
					<IconButton
						color={"primary"}
						onClick={() => {
							downloadItem();
						}}
						title={downloadLabel || "Get data"}
						disabled={loading}
					>
						<GetAppIcon style={{ cursor: "pointer" }} fontSize="small" />
						{loading && <CircularProgress size={16} color="inherit" />}
					</IconButton>
				)}
			</ButtonGroup>
		</>
	);
};
